import { render, staticRenderFns } from "./TokenAccountBalance.vue?vue&type=template&id=112248af"
import script from "./TokenAccountBalance.vue?vue&type=script&lang=ts"
export * from "./TokenAccountBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports